import { useMemo } from 'react';
import { VideoPipManager } from 'utils/pip/video-pip/VideoPipManager';

export const useVideoPipManager = () => useMemo(() => VideoPipManager, []);
